module.exports = __webpack_public_path__ + "img/star.dc741d88.svg";